const parseThousands = (value) => {
    return value !== undefined && value > 999 ? `${Math.round(value / 100) / 10}k` : String(value || 0)
}

export default parseThousands
